export default __webpack_public_path__ + "static/ai-marketing-5-2bfe61c253ffaa7399747f6ddaa9fd62.webp";